import React, { FC, useState } from 'react';
import styled from 'styled-components';

import AnimatedCaret from '@ui/atoms/AnimatedCaret';
import BasicText from '@ui/atoms/BasicText';
import Skeleton from '@ui/atoms/Skeleton';

import useFetchPhoto from '@hooks/useFetchPhoto';

import { exists } from '@utils/general';

import theme from '@theme/FolxTheme';

interface IProfileCardProps {
	open: boolean;
	className?: string;
	handleClick?: () => void;
	name?: string;
}

const StyledProfile = styled.button`
	display: flex;
	align-items: center;
	background: ${theme.colors.white};
	border-radius: ${theme.radius.md};
	box-shadow: ${theme.shadow.profileBox};
	cursor: pointer;
	gap: ${theme.spacing.xs};
	padding: ${theme.spacing.xs} ${theme.spacing.sm};
`;

const StyledSelfie = styled.div<{ placeholder: boolean }>`
	align-items: center;
	background-color: ${theme.colors.lightGray};
	border-radius: 50%;
	display: flex;
	height: ${theme.spacing.lg};
	justify-content: center;
	overflow: hidden;
	width: ${theme.spacing.lg};

	img {
		object-fit: cover;
		height: ${({ placeholder }) => (placeholder ? theme.spacing.lg : '100%')};
		width: ${({ placeholder }) => (placeholder ? theme.spacing.lg : '100%')};
	}
`;

const ProfileCard: FC<IProfileCardProps> = ({ className, handleClick = () => {}, name, open }) => {
	const [placeholder, setPlaceholder] = useState<boolean>(false);

	const { photo: selfie } = useFetchPhoto({
		imageType: 'Selfie',
		handleError: () => setPlaceholder(true),
		callback: () => setPlaceholder(false),
	});

	return (
		<StyledProfile
			aria-label="More Options: Profile Settings, Help, and Sign Out"
			className={className}
			type="button"
			onClick={() => {
				handleClick();
			}}>
			<StyledSelfie placeholder={placeholder}>
				{selfie ? (
					<img src={selfie} alt="a picture of you" />
				) : (
					<Skeleton borderRadius="half" height="lg" />
				)}
			</StyledSelfie>
			{exists(name) ? (
				<BasicText variant="pillText">{name}</BasicText>
			) : (
				<Skeleton height="md" width="xxl" />
			)}
			<AnimatedCaret open={open} width="xssm" />
		</StyledProfile>
	);
};

export default styled(ProfileCard)``;
